import React from 'react'

export const FlagKOSvg = ({size = 16, ...props}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0"
      y="0"
      width={size}
      height={size}
      enableBackground="new 0 0 512 512"
      version="1.1"
      viewBox="0 0 512 512"
      xmlSpace="preserve"
      {...props}
    >
      <circle cx="256" cy="256" r="256" fill="#F0F0F0"></circle>
      <path
        fill="#D80027"
        d="M345.043 256c0 22.261-39.866 77.913-89.043 77.913S166.957 278.261 166.957 256c0-49.178 39.866-89.043 89.043-89.043s89.043 39.865 89.043 89.043z"
      ></path>
      <path
        fill="#0052B4"
        d="M345.043 256c0 49.178-39.866 89.043-89.043 89.043S166.957 305.178 166.957 256"
      ></path>
      <path
        d="M353.427 319.639H386.81800000000004V341.90000000000003H353.427z"
        transform="rotate(-45.001 370.12 330.776)"
      ></path>
      <path
        d="M314.07 358.994H347.461V381.25500000000005H314.07z"
        transform="rotate(-45.001 330.763 370.13)"
      ></path>
      <path
        d="M400.656 366.851H434.047V389.112H400.656z"
        transform="rotate(-45.001 417.35 377.989)"
      ></path>
      <path
        d="M361.299 406.213H394.69V428.47400000000005H361.299z"
        transform="rotate(-45.001 377.992 417.35)"
      ></path>
      <path
        d="M377.04 343.247H410.43100000000004V365.50800000000004H377.04z"
        transform="rotate(-45.001 393.733 354.384)"
      ></path>
      <path
        d="M337.694 382.602H371.08500000000004V404.863H337.694z"
        transform="rotate(-45.001 354.387 393.738)"
      ></path>
      <path
        d="M329.544 126.805H418.587V149.066H329.544z"
        transform="rotate(-134.999 374.067 137.936)"
      ></path>
      <path
        d="M314.081 130.749H347.47200000000004V153.009H314.081z"
        transform="rotate(-134.999 330.778 141.88)"
      ></path>
      <path
        d="M353.427 170.098H386.81800000000004V192.358H353.427z"
        transform="rotate(-134.999 370.124 181.23)"
      ></path>
      <path
        d="M361.282 83.526H394.673V105.78699999999999H361.282z"
        transform="rotate(-134.999 377.98 94.658)"
      ></path>
      <path
        d="M400.651 122.879H434.04200000000003V145.14000000000001H400.651z"
        transform="rotate(-134.999 417.348 134.01)"
      ></path>
      <path
        d="M69.81 386.542H158.853V408.803H69.81z"
        transform="rotate(45.001 114.336 397.673)"
      ></path>
      <path
        d="M140.919 382.6H174.31V404.86H140.919z"
        transform="rotate(45.001 157.62 393.73)"
      ></path>
      <path
        d="M101.569 343.252H134.96V365.51300000000003H101.569z"
        transform="rotate(45.001 118.269 354.382)"
      ></path>
      <path
        d="M117.031 339.316H206.074V361.577H117.031z"
        transform="rotate(45.001 161.557 350.446)"
      ></path>
      <path
        d="M69.81 103.201H158.853V125.46199999999999H69.81z"
        transform="rotate(134.999 114.332 114.331)"
      ></path>
      <path
        d="M93.412 126.806H182.455V149.067H93.412z"
        transform="rotate(134.999 137.934 137.937)"
      ></path>
      <path
        d="M117.038 150.428H206.08100000000002V172.688H117.038z"
        transform="rotate(134.999 161.56 161.558)"
      ></path>
    </svg>
  );
}

export const FlagKOSquareSvg = ({size = 16, ...props}) => {
  return (
      <svg
          xmlns="http://www.w3.org/2000/svg"
          width={size}
          height={size}
          viewBox="0 0 512.001 512.001"
          xmlSpace="preserve"
          {...props}
      >
        <path
            d="M503.172 423.725H8.828A8.829 8.829 0 010 414.897V97.104a8.829 8.829 0 018.828-8.828h494.345a8.829 8.829 0 018.828 8.828v317.793a8.83 8.83 0 01-8.829 8.828z"
            fill="#f5f5f5"
        />
        <path
            d="M305.009 182.533c-40.563-27.041-95.35-15.986-122.374 24.506-13.555 20.211-8.045 47.674 12.235 61.195 20.265 13.521 47.64 8.03 61.161-12.252 13.521-20.281 40.914-25.704 61.178-12.254 20.298 13.521 25.757 40.984 12.217 61.195 27.042-40.56 16.111-95.348-24.417-122.39"
            fill="#ff4b55"
        />
        <path
            d="M182.634 207.04c-13.555 20.211-8.045 47.674 12.235 61.195 20.265 13.521 47.64 8.03 61.161-12.252 13.521-20.281 40.914-25.704 61.178-12.254 20.298 13.521 25.757 40.984 12.217 61.195-27.006 40.632-81.775 51.549-122.338 24.507-40.526-27.04-51.494-81.828-24.453-122.391"
            fill="#41479b"
        />
        <g fill="#464655">
          <path d="M349.92 149.191l16.035 24.102a4.414 4.414 0 01-1.219 6.112l-4.066 2.723a4.414 4.414 0 01-6.129-1.22l-16.055-24.096a4.415 4.415 0 011.223-6.119l4.086-2.728a4.413 4.413 0 016.125 1.226zM374.66 186.352l16.087 24.087a4.415 4.415 0 01-1.237 6.134l-4.084 2.699a4.413 4.413 0 01-6.103-1.23l-16.078-24.062a4.414 4.414 0 011.217-6.122l4.074-2.724a4.415 4.415 0 016.124 1.218zM367.089 137.733l40.829 61.273a4.413 4.413 0 01-1.225 6.12l-4.102 2.734a4.413 4.413 0 01-6.121-1.224l-40.843-61.269a4.413 4.413 0 011.227-6.122l4.115-2.739a4.416 4.416 0 016.12 1.227zM384.211 126.293l16.07 24.149a4.412 4.412 0 01-1.241 6.127l-4.086 2.7a4.412 4.412 0 01-6.105-1.234l-16.082-24.117a4.413 4.413 0 011.224-6.121l4.099-2.732a4.411 4.411 0 016.121 1.228zM408.967 163.532l16.045 24.099a4.413 4.413 0 01-1.22 6.115l-4.075 2.724a4.413 4.413 0 01-6.127-1.223l-16.045-24.099a4.414 4.414 0 011.22-6.115l4.075-2.724a4.413 4.413 0 016.127 1.223zM132.721 293.983l40.824 61.207a4.413 4.413 0 01-1.222 6.12l-4.088 2.73a4.414 4.414 0 01-6.123-1.222l-40.824-61.207a4.413 4.413 0 011.222-6.12l4.088-2.73a4.415 4.415 0 016.123 1.222zM115.582 305.432l16.028 24.041a4.413 4.413 0 01-1.217 6.116l-4.066 2.722a4.414 4.414 0 01-6.126-1.217l-16.047-24.035a4.413 4.413 0 011.22-6.122l4.086-2.728a4.414 4.414 0 016.122 1.223zM140.351 342.606l16.046 24.102a4.412 4.412 0 01-1.222 6.115l-4.078 2.726a4.414 4.414 0 01-6.126-1.221l-16.056-24.097a4.415 4.415 0 011.222-6.119l4.088-2.73a4.414 4.414 0 016.126 1.224zM98.442 316.877l40.798 61.21a4.416 4.416 0 01-1.219 6.118l-4.077 2.726a4.413 4.413 0 01-6.125-1.22l-40.822-61.202a4.415 4.415 0 011.224-6.122l4.102-2.734a4.412 4.412 0 016.119 1.224zM121.294 210.443l40.818-61.257a4.414 4.414 0 016.124-1.224l4.087 2.729a4.415 4.415 0 011.222 6.12l-40.834 61.223a4.414 4.414 0 01-6.108 1.231l-4.071-2.695a4.413 4.413 0 01-1.238-6.127zM104.147 199.01l40.825-61.269a4.414 4.414 0 016.126-1.222l4.077 2.726a4.413 4.413 0 011.22 6.116l-40.814 61.272a4.413 4.413 0 01-6.124 1.224l-4.088-2.729a4.413 4.413 0 01-1.222-6.118zM86.99 187.626l40.829-61.33a4.415 4.415 0 016.127-1.224l4.077 2.726a4.413 4.413 0 011.222 6.114l-40.804 61.339a4.414 4.414 0 01-6.123 1.228l-4.102-2.734a4.416 4.416 0 01-1.226-6.119zM338.493 355.19l16.047-24.035a4.414 4.414 0 016.126-1.217l4.066 2.723a4.414 4.414 0 011.217 6.116l-16.028 24.04a4.414 4.414 0 01-6.123 1.223l-4.086-2.728a4.414 4.414 0 01-1.219-6.122zM363.243 318.142l16.073-24.154a4.415 4.415 0 016.123-1.227l4.096 2.73a4.415 4.415 0 011.223 6.124l-16.107 24.116a4.412 4.412 0 01-6.109 1.227l-4.062-2.692a4.414 4.414 0 01-1.237-6.124zM355.626 366.699l16.057-24.098a4.414 4.414 0 016.122-1.225l4.104 2.737a4.415 4.415 0 011.225 6.119l-16.047 24.1a4.414 4.414 0 01-6.12 1.228l-4.115-2.739a4.416 4.416 0 01-1.226-6.122zM380.403 329.464l16.066-24.042a4.415 4.415 0 016.119-1.22l4.102 2.734a4.413 4.413 0 011.221 6.124l-16.065 24.042a4.414 4.414 0 01-6.118 1.22l-4.103-2.734a4.41 4.41 0 01-1.222-6.124zM372.771 378.082l16.075-24.056a4.414 4.414 0 016.103-1.23l4.086 2.7a4.415 4.415 0 011.239 6.131l-16.063 24.088a4.415 4.415 0 01-6.121 1.224l-4.099-2.732a4.414 4.414 0 01-1.22-6.125zM397.554 340.97l16.035-24.085a4.414 4.414 0 016.127-1.223l4.072 2.722a4.414 4.414 0 011.218 6.119l-16.049 24.053a4.413 4.413 0 01-6.11 1.229l-4.06-2.69a4.414 4.414 0 01-1.233-6.125z" />
        </g>
      </svg>
  )
}
